// extracted by mini-css-extract-plugin
var _1 = "DesktopActionsWidget-modulehidden__s_7t0";
var _2 = "DesktopActionsWidget-moduleshadow__Zcsh3";
var _3 = "DesktopActionsWidget-modulestickyActions__IFhuG";
var _4 = "DesktopActionsWidget-modulewidgets__wsHnb";
export { _1 as "hidden", _2 as "shadow", _3 as "stickyActions", _4 as "widgets" }
